import React from 'react';
import { LinkText } from '@/components/atoms'
import CustomDataTable from '@/components/organisms/CustomDataTable/CustomDataTable'
import { useActivites } from '@/containers/Activity/useActivites'
import { getCellDataMappedCols } from '@/helpers/dataTableCellDataMapper'
import { useState } from 'react'
import { isPublished } from '@/utils/commons'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@/utils/constants/routesConstants'
import { Constants } from '@/utils/constants/commonConstants'

const cellDataMapperObj = navigate => ({
  activityTitle: {
    cellData: ({ row: { original } = {} }) => {
      const isPublishedStatus = isPublished(original?.status);
      const queryParam = isPublishedStatus ? `?review=${Constants.ReviewPublished}` : '';
      return (
        <LinkText
          text={original?.activityTitle}
          id={original?.activityTitle + ' ' + original?.id || original?.uuid}
          handleClick={() => navigate(`${ROUTES.ACTIVITY_VIEW.replace(':id', original?.id || original?.uuid)}${queryParam}`)}
        />
      );
    },
    linkHandler: (row) => {
      const isPublishedStatus = isPublished(row?.status);
      const queryParam = isPublishedStatus ? `?review=${Constants.ReviewPublished}` : '';
      return navigate(`${ROUTES.ACTIVITY_VIEW.replace(':id', row?.id || row?.uuid)}${queryParam}`);
    },
    linkLabel: (row) => row.activityTitle || '—',
  },
  customers_count: ({ row: { original } = {} }) => {
    return <div className="txtRightAlign">{original?.numberOfCustomers}</div>
  },
  percent_completed: ({ row: { original } = {} }) => {
    return <div className="txtRightAlign">{original?.percentageCompleted}</div>
  },
  points_awarded: ({ row: { original } = {} }) => {
    return <div className="txtRightAlign">{original?.totalPointsAwarded}</div>
  },
  status: ({ row: { original } = {} }) => {
    return <div className={original?.status === 'Cancelled' ? 'status_error' : ''}>{original?.status}</div>
  },
})
export const SalesTargetsActivitiesList = () => {
  const {
    activityListData,
    activityLColConfigData,
    pageIndex,
    setPageIndex,
    setSortingObj,
    sortingObj,
    setSearchArry,
    onDownloadBtnClick,
    handleResetAll
  } = useActivites()

  const [rowSelected, setRowSelected] = useState([])
  const [isSelectAll, setIsSelectAll] = useState(false)
  const navigate = useNavigate()
  const cellDataMappedCols = getCellDataMappedCols(cellDataMapperObj(navigate), activityLColConfigData)

  const isLoading = !activityListData?.data || activityLColConfigData?.length === 0

  const onDownloadClick = async () => {
    const ids = rowSelected.map(item => item?.id || item?.uuid);
    onDownloadBtnClick(isSelectAll ? [] : ids)
  }

  return (
    <div className="salesTargetsActiviesDataTable">
      <CustomDataTable
        columns={cellDataMappedCols}
        records={activityListData?.data || []}
        isLoading={isLoading}
        pageSize={activityListData?.pageSize || 10}
        totalRecords={activityListData?.totalRecords || 0}
        setPageIndex={setPageIndex}
        handleSorting={setSortingObj}
        setSearchArry={setSearchArry}
        onResetAll={handleResetAll}
        onRowSelect={(selectedRecords, isAll) => {
          setRowSelected(selectedRecords)
          setIsSelectAll(isAll)
        }}
        onDownload={onDownloadClick}
        showDownload={true}
        isSelectAll={isSelectAll}
        pageIndex={pageIndex}
        initialSortConfig={sortingObj}
      />
      {activityListData?.totalRecords && (
        <div className="txtRightAlign">{activityListData?.totalRecords} total items</div>
      )}
    </div>
  )
}
